export const Colors = {
  gray: '#D4D6D8',
  graphMainColor: '#0468B1',
  primaryColors: {
    'blue-100': '#B5D5F5',
    'blue-200': '#94C4F5',
    'blue-300': '#6BABEB',
    'blue-400': '#4F95DD',
    'blue-500': '#3288CE',
    'blue-600': '#0468B1',
    'blue-700': '#1F5A95',
  },
  genderColors: {
    male: '#02A38A',
    female: '#757AF0',
  },
  locationColors: {
    urban: '#0468B1',
    rural: '#5DD4F0',
  },
  alerts: {
    lightYellow: '#FFE17E',
    yellow: '#FFEB00',
    darkYellow: '#FBC412',
    lightRed: '#FFBCB7',
    red: '#EE402D',
    darkRed: '#D12800',
    lightGreen: '#B8ECB6',
    green: '#6DE354',
    darkGreen: '#59BA47',
    lightAzure: '#A2DAF3',
    azure: '#60D4F2',
    darkAzure: '#00C1FF',
  },
  sdgColors: {
    sdg1: '#E5243B',
    sdg2: '#DDA63A',
    sdg3: '#4C9F38',
    sdg4: '#C5192D',
    sdg5: '#FF3A21',
    sdg6: '#26BDE2',
    sdg7: '#FCC30B',
    sdg8: '#A21942',
    sdg9: '#FD6925',
    sdg10: '#DD1367',
    sdg11: '#FD9D24',
    sdg12: '#BF8B2E',
    sdg13: '#3F7E44',
    sdg14: '#0A97D9',
    sdg15: '#56C02B',
    sdg16: '#00689D',
    sdg17: '#19486A',
  },
  light: {
    graphBackgroundColor: '#F7F7F7',
    graphNoData: '#FAFAFA',
    grays: {
      white: '#FFFFFF',
      'gray-100': '#FAFAFA',
      'gray-200': '#F7F7F7',
      'gray-300': '#EDEFF0',
      'gray-400': '#D4D6D8',
      'gray-500': '#A9B1B7',
      'gray-530': '#84929d',
      'gray-560': '#677383',
      'gray-600': '#55606E',
      'gray-700': '#232E3D',
      black: '#000000',
    },
    categoricalColors: {
      colors: [
        '#0468B1',
        '#5DD4F0',
        '#02A38A',
        '#E78625',
        '#E0529E',
        '#757AF0',
        '#A0C236',
        '#FBC412',
        '#BF8B2E',
        '#A9B1B7',
      ],
    },
    sequentialColors: {
      negativeColorsx02: ['#f6b666', '#a71c04'],
      negativeColorsx03: ['#f6b666', '#d16f34', '#a71c04'],
      negativeColorsx04: ['#F6B666', '#EB8033', '#D64513', '#A71C04'],
      negativeColorsx05: ['#FBD68A', '#F39E4B', '#E16424', '#C12705', '#850E02'],
      negativeColorsx06: ['#FFF4AC', '#F7BD6D', '#EC8234', '#D54211', '#A01903', '#650000'],
      negativeColorsx07: [
        '#FFF4AC',
        '#F8C678',
        '#F29641',
        '#E16424',
        '#C92B06',
        '#961503',
        '#650000',
      ],
      negativeColorsx08: [
        '#FFF4AC',
        '#F9CD7F',
        '#F4A451',
        '#E97A30',
        '#D94C17',
        '#BB2505',
        '#8F1202',
        '#650000',
      ],
      negativeColorsx09: [
        '#FFF4AC',
        '#FAD285',
        '#F5AE5D',
        '#EE8938',
        '#E16424',
        '#D2390C',
        '#ad190d',
        '#891002',
        '#650000',
      ],
      negativeColorsx10: [
        '#FFF4AC',
        '#FBD68A',
        '#F6B666',
        '#F29641',
        '#E7752D',
        '#DB521A',
        '#C92B06',
        '#A71C04',
        '#850E02',
        '#650000',
      ],

      positiveColorsx02: ['#bada81', '#308c56'],
      positiveColorsx03: ['#bada81', '#6eb560', '#308c56'],
      positiveColorsx04: ['#BADA81', '#7FC45F', '#58A85A', '#308C56'],
      positiveColorsx05: ['#DDE797', '#9FD071', '#6CB65D', '#429858', '#187B54'],
      positiveColorsx06: ['#FFF4AC', '#C1DD85', '#81C55F', '#56A75A', '#2C8956', '#006A51'],
      positiveColorsx07: [
        '#FFF4AC',
        '#CBE18C',
        '#96CD6B',
        '#6CB65D',
        '#489D59',
        '#248455',
        '#006A51',
      ],
      positiveColorsx08: [
        '#FFF4AC',
        '#D3E491',
        '#A6D374',
        '#7BC05E',
        '#5CAB5B',
        '#3E9558',
        '#1F8054',
        '#006A51',
      ],
      positiveColorsx09: [
        '#FFF4AC',
        '#D8E694',
        '#B1D77C',
        '#88C862',
        '#6CB65D',
        '#51A35A',
        '#369057',
        '#1B7D54',
        '#006A51',
      ],
      positiveColorsx10: [
        '#FFF4AC',
        '#DDE797',
        '#BADA81',
        '#96CD6B',
        '#78BE5E',
        '#60AD5B',
        '#489D59',
        '#308C56',
        '#187B54',
        '#006A51',
      ],

      neutralColorsx02: ['#5fcda1', '#005396'],
      neutralColorsx03: ['#5fcda1', '#458e9d', '#005396'],
      neutralColorsx04: ['#FFF4AC', '#5FCDA1', '#0091A9', '#005396'],
      neutralColorsx05: ['#FFF4AC', '#7BD4A3', '#00A5A1', '#006CB3', '#003F80'],
      neutralColorsx06: ['#FFF4AC', '#98DBA5', '#16BB9C', '#008FA9', '#0063A8', '#003F80'],
      neutralColorsx07: [
        '#FFF4AC',
        '#AADFA6',
        '#47C79F',
        '#00A5A1',
        '#007FAF',
        '#005DA1',
        '#003F80',
      ],
      neutralColorsx08: [
        '#FFF4AC',
        '#B7E2A7',
        '#66CFA2',
        '#00B59B',
        '#0095A7',
        '#0074B3',
        '#00589D',
        '#003F80',
      ],
      neutralColorsx09: [
        '#FFF4AC',
        '#C1E5A8',
        '#7CD4A3',
        '#29C09D',
        '#00A5A1',
        '#0089AB',
        '#006CB3',
        '#005599',
        '#003F80',
      ],
      neutralColorsx10: [
        '#FFF4AC',
        '#C8E7A8',
        '#8CD8A4',
        '#47C79F',
        '#00B29C',
        '#0099A5',
        '#007FAF',
        '#0067AD',
        '#005396',
        '#003F80',
      ],
    },
    divergentColors: {
      colorsx02: ['#d9382d', '#347cbc'],
      colorsx03: ['#d9382d', '#ffffbf', '#347cbc'],
      colorsx04: ['#d9382d', '#eea57d', '#89bfdc', '#347cbc'],
      colorsx05: ['#d9382d', '#eea57d', '#ffffbf', '#89bfdc', '#347cbc'],
      colorsx06: ['#d9382d', '#e88666', '#f6d39e', '#bae0e1', '#70a8cc', '#347cbc'],
      colorsx07: ['#d9382d', '#e88666', '#f6d39e', '#ffffbf', '#bae0e1', '#70a8cc', '#347cbc'],
      colorsx08: [
        '#d9382d',
        '#e47559',
        '#eea57d',
        '#f6d39e',
        '#bae0e1',
        '#89bfdc',
        '#5f9dcc',
        '#347cbc',
      ],
      colorsx09: [
        '#d9382d',
        '#e47559',
        '#eea57d',
        '#f6d39e',
        '#ffffbf',
        '#bae0e1',
        '#89bfdc',
        '#5f9dcc',
        '#347cbc',
      ],
      colorsx10: [
        '#aa1d09',
        '#d9382d',
        '#e47559',
        '#eea57d',
        '#f6d39e',
        '#bae0e1',
        '#89bfdc',
        '#5f9dcc',
        '#347cbc',
        '#095aab',
      ],
      colorsx11: [
        '#aa1d09',
        '#d9382d',
        '#e47559',
        '#eea57d',
        '#f6d39e',
        '#ffffbf',
        '#bae0e1',
        '#89bfdc',
        '#5f9dcc',
        '#347cbc',
        '#095aab',
      ],
    },
    bivariateColors: {
      colors03x03: [
        ['#e5e5e5', '#7FDCF9', '#0BC6FF'],
        ['#F99FBA', '#9697D3', '#3690EB'],
        ['#F4618D', '#A961B3', '#5C61DA'],
      ],
      colors04x04: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4'],
      ],
      colors05x04: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4'],
        ['#F4618D', '#D2619F', '#A961B3', '#8061C8'],
      ],
      colors04x05: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC', '#0BC6FF'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED', '#21ABF5'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF', '#3690EB'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4', '#4978E3'],
      ],
      colors05x05: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC', '#0BC6FF'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED', '#21ABF5'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF', '#3690EB'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4', '#4978E3'],
        ['#F4618D', '#D2619F', '#A961B3', '#8061C8', '#5C61DA'],
      ],
    },
  },
  dark: {
    graphBackgroundColor: '#232E3D',
    graphNoData: '#394250',
    grays: {
      white: '#232E3D',
      'gray-100': '#394250',
      'gray-200': '#47505C',
      'gray-300': '#57606D',
      'gray-400': '#78808A',
      'gray-500': '#677383',
      'gray-530': '#84929d',
      'gray-560': '#AAB1B6',
      'gray-600': '#D4D6D8',
      'gray-700': '#EAEBEC',
      black: '#FFFFFF',
    },
    categoricalColors: {
      colors: [
        '#0468B1',
        '#5DD4F0',
        '#02A38A',
        '#E78625',
        '#E0529E',
        '#757AF0',
        '#A0C236',
        '#FBC412',
        '#BF8B2E',
        '#A9B1B7',
      ],
    },
    sequentialColors: {
      negativeColorsx02: ['#a71c04', '#f6b666'],
      negativeColorsx03: ['#a71c04', '#d16f34', '#f6b666'],
      negativeColorsx04: ['#A71C04', '#D64513', '#EB8033', '#F6B666'],
      negativeColorsx05: ['#850E02', '#C12705', '#E16424', '#F39E4B', '#FBD68A'],
      negativeColorsx06: ['#650000', '#A01903', '#D54211', '#EC8234', '#F7BD6D', '#FFF4AC'],
      negativeColorsx07: [
        '#650000',
        '#961503',
        '#C92B06',
        '#E16424',
        '#F29641',
        '#F8C678',
        '#FFF4AC',
      ],
      negativeColorsx08: [
        '#650000',
        '#8F1202',
        '#BB2505',
        '#D94C17',
        '#E97A30',
        '#F4A451',
        '#F9CD7F',
        '#FFF4AC',
      ],
      negativeColorsx09: [
        '#650000',
        '#891002',
        '#ad190d',
        '#D2390C',
        '#E16424',
        '#EE8938',
        '#F5AE5D',
        '#FAD285',
        '#FFF4AC',
      ],
      negativeColorsx10: [
        '#650000',
        '#850E02',
        '#A71C04',
        '#C92B06',
        '#DB521A',
        '#E7752D',
        '#F29641',
        '#F6B666',
        '#FBD68A',
        '#FFF4AC',
      ],

      positiveColorsx02: ['#308c56', '#bada81'],
      positiveColorsx03: ['#308c56', '#6eb560', '#bada81'],
      positiveColorsx04: ['#308C56', '#58A85A', '#7FC45F', '#BADA81'],
      positiveColorsx05: ['#187B54', '#429858', '#6CB65D', '#9FD071', '#DDE797'],
      positiveColorsx06: ['#006A51', '#2C8956', '#56A75A', '#81C55F', '#C1DD85', '#FFF4AC'],
      positiveColorsx07: [
        '#006A51',
        '#248455',
        '#489D59',
        '#6CB65D',
        '#96CD6B',
        '#CBE18C',
        '#FFF4AC',
      ],
      positiveColorsx08: [
        '#006A51',
        '#1F8054',
        '#3E9558',
        '#5CAB5B',
        '#7BC05E',
        '#A6D374',
        '#D3E491',
        '#FFF4AC',
      ],
      positiveColorsx09: [
        '#006A51',
        '#1B7D54',
        '#369057',
        '#51A35A',
        '#6CB65D',
        '#88C862',
        '#B1D77C',
        '#D8E694',
        '#FFF4AC',
      ],
      positiveColorsx10: [
        '#006A51',
        '#187B54',
        '#308C56',
        '#489D59',
        '#60AD5B',
        '#78BE5E',
        '#96CD6B',
        '#BADA81',
        '#DDE797',
        '#FFF4AC',
      ],

      neutralColorsx02: ['#005396', '#5fcda1'],
      neutralColorsx03: ['#005396', '#458e9d', '#5fcda1'],
      neutralColorsx04: ['#005396', '#0091A9', '#5FCDA1', '#FFF4AC'],
      neutralColorsx05: ['#003F80', '#006CB3', '#00A5A1', '#7BD4A3', '#FFF4AC'],
      neutralColorsx06: ['#003F80', '#0063A8', '#008FA9', '#16BB9C', '#98DBA5', '#FFF4AC'],
      neutralColorsx07: [
        '#003F80',
        '#005DA1',
        '#007FAF',
        '#00A5A1',
        '#47C79F',
        '#AADFA6',
        '#FFF4AC',
      ],
      neutralColorsx08: [
        '#003F80',
        '#00589D',
        '#0074B3',
        '#0095A7',
        '#00B59B',
        '#66CFA2',
        '#B7E2A7',
        '#FFF4AC',
      ],
      neutralColorsx09: [
        '#003F80',
        '#005599',
        '#006CB3',
        '#0089AB',
        '#00A5A1',
        '#29C09D',
        '#7CD4A3',
        '#C1E5A8',
        '#FFF4AC',
      ],
      neutralColorsx10: [
        '#003F80',
        '#005396',
        '#0067AD',
        '#007FAF',
        '#0099A5',
        '#00B29C',
        '#47C79F',
        '#8CD8A4',
        '#C8E7A8',
        '#FFF4AC',
      ],
    },
    divergentColors: {
      colorsx02: ['#347cbc', '#d9382d'],
      colorsx03: ['#347cbc', '#ffffbf', '#d9382d'],
      colorsx04: ['#347cbc', '#89bfdc', '#eea57d', '#d9382d'],
      colorsx05: ['#347cbc', '#89bfdc', '#ffffbf', '#eea57d', '#d9382d'],
      colorsx06: ['#347cbc', '#70a8cc', '#bae0e1', '#f6d39e', '#e88666', '#d9382d'],
      colorsx07: ['#347cbc', '#70a8cc', '#bae0e1', '#ffffbf', '#f6d39e', '#e88666', '#d9382d'],
      colorsx08: [
        '#347cbc',
        '#5f9dcc',
        '#89bfdc',
        '#bae0e1',
        '#f6d39e',
        '#eea57d',
        '#e47559',
        '#d9382d',
      ],
      colorsx09: [
        '#347cbc',
        '#5f9dcc',
        '#89bfdc',
        '#bae0e1',
        '#ffffbf',
        '#f6d39e',
        '#eea57d',
        '#e47559',
        '#d9382d',
      ],
      colorsx10: [
        '#095aab',
        '#347cbc',
        '#5f9dcc',
        '#89bfdc',
        '#bae0e1',
        '#f6d39e',
        '#eea57d',
        '#e47559',
        '#d9382d',
        '#aa1d09',
      ],
      colorsx11: [
        '#095aab',
        '#347cbc',
        '#5f9dcc',
        '#89bfdc',
        '#bae0e1',
        '#ffffbf',
        '#f6d39e',
        '#eea57d',
        '#e47559',
        '#d9382d',
        '#aa1d09',
      ],
    },
    bivariateColors: {
      colors03x03: [
        ['#e5e5e5', '#7FDCF9', '#0BC6FF'],
        ['#F99FBA', '#9697D3', '#3690EB'],
        ['#F4618D', '#A961B3', '#5C61DA'],
      ],
      colors04x04: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4'],
      ],
      colors05x04: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4'],
        ['#F4618D', '#D2619F', '#A961B3', '#8061C8'],
      ],
      colors04x05: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC', '#0BC6FF'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED', '#21ABF5'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF', '#3690EB'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4', '#4978E3'],
      ],
      colors05x05: [
        ['#e5e5e5', '#BAE7F6', '#7FDCF9', '#41D0FC', '#0BC6FF'],
        ['#F6C5D4', '#BFBEDD', '#88B8E5', '#57B2ED', '#21ABF5'],
        ['#F99FBA', '#C89BC6', '#9697D3', '#6494DF', '#3690EB'],
        ['#F782A5', '#D180B3', '#9F7DC5', '#727AD4', '#4978E3'],
        ['#F4618D', '#D2619F', '#A961B3', '#8061C8', '#5C61DA'],
      ],
    },
  },
};
